// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import store from './assets/unit/store';

import unit from './assets/unit/unit';
import unit1 from './assets/unit/util';
import './assets/iconfont/iconfont.css'
import datalist from './assets/unit/datalist.js'
import EleForm from 'vue-ele-form'
import '@/assets/css/resrt.css'
import EleFormJsonEditor from 'vue-ele-form-json-editor'
// 注册 ele-form
// Vue.use(EleForm, {
//   // 可以在这里设置全局的 json-editor 属性
//   'json-editor': {
//     height: 300
//   }
// })
// 注册 json 组件
Vue.component('json-editor', EleFormJsonEditor)

Vue.config.productionTip = false

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'



Vue.prototype.$axios = axios;
Vue.prototype.$Datalist = datalist
Vue.prototype.$Store = store
Vue.prototype.$Unit = unit
Vue.prototype.$Unit1 = unit1

Vue.use(VXETable);
Vue.use(ElementUI);

import base from './assets/unit/log.js'
Vue.use(base)
import { message } from './assets/unit/message';
Vue.prototype.$message = message

// 首先对拦截器的请求进行设置，并在方法中return config，此处为固定格式
axios.interceptors.request.use(config => {
  // 表示在配置中的设置头消息的字段Authorization为从本地获取的token值
  // config.headers.Authorization = localStorage.getItem('agttoken');
  config.headers.token = localStorage.getItem('agttoken');
  return config
})
// axios.defaults.baseURL = 'https://app.ncerp.cn:29601/api/erp/';
// axios.defaults.baseURL = 'https://app.ncerp.cn:9611/erp/';
// axios.defaults.baseURL = 'https://app.ncerp.cn:9615/erp/';
if (localStorage.getItem('agtmainapi')) {
  console.log("test")
  axios.defaults.baseURL = localStorage.getItem('agtmainapi');
} else {
  axios.defaults.baseURL = 'https://www.ncerp.cn/erp/';
}



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',

})


// WEBPACK FOOTER //
// ./src/main.js